import { apiService } from './apiService';

export const getAllUsers = async () => {
  return await apiService.request('/users', { method: 'GET' });
};

export const resetUserPassword = async (userId, newPassword) => {
  return await apiService.request(`/users/${userId}/reset-password`, {
    method: 'POST',
    body: JSON.stringify({ newPassword }),
  });
};

export const createUser = async (userData) => {
  return await apiService.request('/users', {
    method: 'POST',
    body: JSON.stringify(userData),
  });
};

export const updateUser = async (userId, userData) => {
  return await apiService.request(`/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(userData),
  });
};

export const deleteUser = async (userId) => {
  return await apiService.request(`/users/${userId}`, { method: 'DELETE' });
};

